export type TagsConfig<T extends string> = {
  defaultTags: readonly T[];
  tagsByType?: Partial<Record<string, readonly T[]>>;
};

export const resolveTagsForType = <T extends string>(
  config: TagsConfig<T>,
  typeKey?: string,
): T[] => {
  if (typeKey && config.tagsByType?.[typeKey]) {
    return [...config.tagsByType[typeKey]!];
  }

  return [...config.defaultTags];
};

// Backward compatibility aliases.
export type HiddenTagsConfig<T extends string> = {
  defaultHiddenTags: readonly T[];
  hiddenTagsByType?: Partial<Record<string, readonly T[]>>;
};

export const resolveHiddenTagsForType = <T extends string>(
  config: HiddenTagsConfig<T>,
  typeKey?: string,
): T[] => resolveTagsForType(
    {
      defaultTags: config.defaultHiddenTags,
      tagsByType: config.hiddenTagsByType,
    },
    typeKey,
  );
